import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Center, Button as ButtonNewSale, csx } from '@vtex/admin-ui'

import { newOrder } from '@/checkout-instore-legacy/utils/SidebarUtils'

export function NewSaleButton() {
  return (
    <Center>
      <ButtonNewSale
        data-testid="start-new-sale-button"
        variant="tertiary"
        className={csx({
          width: 430,
          marginTop: '$space-2',
        })}
        onClick={newOrder}
      >
        <FormattedMessage id={'newSaleButton'} />
      </ButtonNewSale>
    </Center>
  )
}
